import React, { useEffect, useState, useContext } from 'react';
import { Modal, Box, Button, Typography } from '@mui/material';
import { getMaintenance } from '../../api/settings';
import { StoreContext } from '../Store';
import DOMPurify from 'dompurify';
import './MaintenanceBanner.css';

const MaintenanceBanner = ({ previewData }) => {
  const store = useContext(StoreContext);

  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [banner, setBanner] = useState({});

  const htmlSanitizeConfig = {
    ALLOWED_TAGS: ['b', 'i', 'em', 'u', 'strong', 'a', 'p', 'br'],
    ALLOWED_ATTR: ['href', 'target'],
  };

  const onHide = () => {
    setShowMoreInfo(false);
  };

  const fetchData = async () => {
    if (!previewData) {
      const data = await getMaintenance();
      if (data) {
        setBanner(data);
      }
    }
  };

  useEffect(() => {
    // fetch data on component mount
    fetchData();
  }, []);

  useEffect(() => {
    // fetch data if maintenanceRefresh is triggered (i.e. from the MaintenanceDetails component)
    if (store.maintenanceRefresh && store.maintenanceRefresh[0]) {
      fetchData();
      store.maintenanceRefresh[1](false);
    }
  }, [store.maintenanceRefresh && store.maintenanceRefresh[0]]);

  useEffect(() => {
    if (previewData) {
      setBanner({ ...previewData });
    }
  }, [previewData]);

  return (
    <>
      {banner.enabled && (
        <div className="maintenance-banner">
          <p>
            {banner.bannerText}
            {banner.moreInfo !== '' && (
              <button className="more-info-button" onClick={() => setShowMoreInfo(true)}>
                [More info]
              </button>
            )}
          </p>
        </div>
      )}

      <Modal open={showMoreInfo} onClose={onHide} className="maintenance-banner-modal">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: 800,
            bgcolor: 'background.paper',
            border: 'none',
            outline: 'none',
            p: 4,
            borderRadius: 5,
          }}
        >
          <Box sx={{ py: 3, px: 3 }}>
            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 2 }}>
              {banner?.bannerText}
            </Typography>
          </Box>
          <Box
            sx={{ py: 1, px: 3, whiteSpace: 'pre-wrap', maxHeight: '60vh', overflowY: 'auto' }}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(banner?.moreInfo, htmlSanitizeConfig) }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', pb: 3, px: 3 }}>
            <Button variant="contained" onClick={() => setShowMoreInfo(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default MaintenanceBanner;
